// import waitForElementTransition from '../../../../node_modules/wait-for-element-transition/dist/wait-for-element-transition.js';
import _debounce from 'lodash.debounce';

document.addEventListener('click', (e) => {
  if (!e.target.matches('.horizontal-nav__links')) return false;
  e.target.classList.add('horizontal-nav__links--active');
  document.body.classList.add('hz-is-open');
});

document.addEventListener('click', (e) => {
  if (!e.target.matches('.horizontal-nav__link a')) return false;
  if (e.target.matches('.horizontal-nav__link--active > a')) e.preventDefault();
  e.target.closest('.horizontal-nav__links').classList.remove('horizontal-nav__links--active');
  document.body.classList.remove('hz-is-open');
});

// Hide/Show on Scroll
const horizontalNavStop = (modifierSelector = false, navbarCheck = false) => (e) => {
  const hNav = document.querySelector('.horizontal-nav');
  const stopEl = document.querySelector('[data-horizontal-hide]');
  if (!hNav || !stopEl) return window.removeEventListener(e.type, horizontalNavStop);
  let modifier = hNav.getBoundingClientRect().height;
  if (modifierSelector && document.querySelector(modifierSelector)) { modifier += document.querySelector(modifierSelector).getBoundingClientRect().height; }
  if (navbarCheck) modifier += document.querySelector('.navbar').getBoundingClientRect().height;
  const toHide = stopEl.getBoundingClientRect().top < modifier;
  hNav.classList[toHide ? 'add' : 'remove']('horizontal-nav--hidden');
};
window.addEventListener('scrollUp', horizontalNavStop('#wpadminbar', true));
window.addEventListener('scrollDown', horizontalNavStop());

/**
 * Handles visibility of default link in case no other items are set to 'active',
 * otherwise the nav will never display on smaller breakpoints.
 */
function _handleHNavMobileDefaultLinkVisibility() {
  // Under breakpoint (mobile nav displayed)
  if (window.matchMedia('(max-width: 1023px)').matches) {
    if ( document.querySelector('.horizontal-nav__link--active') === null ) {
      document.querySelector('.js-hnav-default-mobile-link').classList.add('horizontal-nav__link--active');
    }
  } else { // Over breakpoint (full nav displayed)
    document.querySelector('.js-hnav-default-mobile-link').classList.remove('horizontal-nav__link--active');
  }
}

/**
 * On page load
 * - sets active classes on nav items by comparing url paths (no host or protocol, but including fragments)
 * - handle visibility of default mobile link to ensure the navigation is displayed on smaller breakpoints
 */
function setActiveClassesOnNavItems() {
  const hNav = document.querySelector('.horizontal-nav');
  if (hNav !== null) {
    let currentUrlPath = window.location.pathname;

    if ( window.location.hash.length ) {
      currentUrlPath += window.location.hash;
    }

    // Sets 'active' class on item that matches the current url
    document.querySelectorAll('.js-hnav-link').forEach(node => {
      if ( node.getAttribute('data-url-path') === currentUrlPath ) {
        node.classList.add('horizontal-nav__link--active');
      }
    });

    // No items were set as 'active', run fallback menu visibility handler
    if ( document.querySelector('.horizontal-nav__link--active') === null ) {
      // Handle visibility of default mobile link
      window.onresize = _debounce(() => {
        _handleHNavMobileDefaultLinkVisibility();
      }, 200);
      _handleHNavMobileDefaultLinkVisibility();
    } else {
      // No need for the element, remove it from the DOM
      document.querySelector('.js-hnav-default-mobile-link').remove();
    }
  }
}
setActiveClassesOnNavItems();

